import { render } from "./UserAvatarComponent.vue?vue&type=template&id=7a4276c8"
import script from "./UserAvatarComponent.vue?vue&type=script&lang=js"
export * from "./UserAvatarComponent.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/kinetics/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__